import { useTranslation } from 'react-i18next';

/**
 * Marks a FanCam / TIRI row whose content has been deleted. Insights keeps the item — its events
 * are append-only and the engagement really happened — so without this a deleted post would read
 * exactly like a live one. Renders nothing for a live row.
 *
 * With `showDate`, also names when: `deletedAt` is absent for an item deleted before delete
 * events recorded a snapshot, and the pill then just says "Deleted".
 */
const DeletedBadge = ({ deleted, deletedAt, showDate = false, className = '' }) => {
  const { t, i18n } = useTranslation();
  if (!deleted) return null;

  const label =
    showDate && deletedAt
      ? t('admin.insights.deletedOn', {
          date: new Date(deletedAt).toLocaleDateString(i18n.language)
        })
      : t('admin.insights.deleted');

  return (
    <span
      className={`px-2 py-[1px] rounded-full text-[10px] font-semibold whitespace-nowrap bg-[#FEE2E2] text-[#B91C1C] ${className}`}
    >
      {label}
    </span>
  );
};

export default DeletedBadge;
